import React, { PropTypes } from 'react';
import { withReflex } from 'reflexbox';

const propTypes = {
  background: PropTypes.string.isRequired,
  foreground: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
};

const defaultProps = {
  background: '#ffffff',
  foreground: '#ffffff',
};

function Logo({background, foreground, height, width, ...props}) {
  return (
    <svg
      {...props}
      x="0px"
      y="0px"
      enableBackground="new 0 0 100 100"
      height={height}
      width={width}
      viewBox="0 0 100 100">
      <path
        fill={foreground}
        d="M70.383,30.572c3.853,0.907,7.064,4.04,9.365,9.6c-3.007-9.986-8.284-16.827-14.656-16.507  c-7.688,0.388-11.813,4.281-16.198,16.348l-0.004,0.003c-0.012,0.037-0.024,0.074-0.037,0.109  c-1.466,4.051-2.964,9.015-4.633,15.074c-3.156,10.044-5.999,16.471-14.746,14.409c-3.857-0.913-7.085-4.617-9.387-10.176  c3.008,9.985,7.667,17.964,14.04,17.643c7.622-0.385,11.623-3.321,15.897-14.642c0.001-0.006,0.004-0.012,0.005-0.019  c1.657-4.389,3.353-10.036,5.318-17.284l-0.017-0.015C58.47,35.432,62.115,28.622,70.383,30.572z"
      />
      <path
        fill={background}
        d="M81,49c-2.733-19.842-14.498-18.034-14.498-18.034C69.521,31.553,73.25,42.75,74,49h-9.009l12.466,13.467L89.927,49H81z"
      />
      <path
        fill={background}
        d="M33.416,69.034C30.396,68.446,26.668,58,25.918,51h9.009L22.461,37.533L9.991,51h8.927  C21.651,71,33.416,69.034,33.416,69.034z"
      />
    </svg>
  );
}

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default withReflex()(Logo);



/** WEBPACK FOOTER **
 ** ./src/components/Logo.js
 **/